/**
 * Keeps the header in Horizon's "drawer" menu style at every width.
 *
 * Horizon decides between an inline menu and a burger at runtime:
 * setHeaderMenuStyle() in utilities.js writes data-menu-style="drawer" only
 * on touch devices or once the nav has run out of room, and "menu"
 * otherwise. Drawer mode is not just a burger — it also switches the header
 * grid to the five-area layout that puts the logo in the centre cell, which
 * is exactly the arrangement we want on desktop too.
 *
 * Rather than duplicate that whole grid in our own CSS, hold the attribute
 * on "drawer" and let the theme lay itself out. Horizon rewrites the
 * attribute on resize and on hydration, so an observer puts it back.
 */

const FORCED = 'drawer';

function init() {
  const header = document.querySelector('#header-component');
  if (!header) return;

  const hold = () => {
    if (header.dataset.menuStyle !== FORCED) header.dataset.menuStyle = FORCED;
  };

  hold();

  // Guarded by the equality check above, so putting the value back does not
  // re-trigger this observer into a loop.
  new MutationObserver(hold).observe(header, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
